















import Spinner from "vue-simple-spinner";
import sleep from "sleep-promise";
import { Election, Voter, Vue } from "@/types.ts";

export default Vue.extend({
  components: {
    Spinner,
  },
  data() {
    return {
      status: "ready" as "ready" | "sending" | "sent",
    };
  },
  methods: {
    async sendEmail(voter: Voter, event: MouseEvent) {
      let email = null;
      if (event.ctrlKey) {
        const forced = window.prompt(
          "Attention, l'anomalie sera signalée aux scrutateurs",
          voter.email
        );
        if (!forced) return;
        email = forced;
      }
      this.status = "sending";
      await this.$store.dispatch("sendEmail", {
        election: this.election,
        email,
        voter,
      });
      await sleep(200);
      this.status = "sent";
    },
  },
  props: {
    election: {
      type: Object as () => Election,
      required: true,
    },
    voter: {
      type: Object as () => Voter,
      required: true,
    },
  },
});
